export default __webpack_public_path__ + "static/media/Long Put.97857618.svg";